<template>
  <div>
    <footer>
      <div class="footer">
        <div class="container">
          <div class="siteinfo">
            <div class="content" style="max-width: 1000px;margin: 0 auto;">
              <div class="nav-left contactUs">
                <h3>联系我们</h3>
                <p>客服：13272494143</p>
                <p>商务：13272494143</p>
                <p>邮箱：yilinwulia@yilwl.com</p>
                <p>地址：长沙市宁乡市玉屏山国际产业城D5栋</p>
                <p>工作日：09:00 - 18:00</p>
                <p>节假日：10:00 - 17:00</p>
              </div>
              <div class="nav-left weixin">
                <h3>微信</h3>
                <p>
                  <img src="@/assets/images/weixin/weixin_qrcode.png" alt="微信">
                </p>
              </div>
              <div class="nav-left weibo">
                <h3>微博</h3>
                <p>
                  <img src="@/assets/images/weibo/weibo_qrcode.png" alt="微博">
                </p>
              </div>
            </div>
          </div>
          <div class="copyright">
            <h5>&copy;&nbsp;<span>{{new Date().getFullYear()}}</span>&nbsp;长沙一麟物联科技有限公司&nbsp;版权所有</h5>
            <!-- <h5 class="company">公司名称</h5>
            <h6>
              <a href="http://www.beian.miit.gov.cn/" target="_blank">
                <span>湘公网安备43012402000786号</span>
              </a>
              <a href="https://beian.mps.gov.cn/#/query/webSearch?code=43012402000786" target="_blank">
                <span>湘公网安备43012402000786号</span>
              </a>
            </h6> -->
            <div style="width:300px;margin:0 auto; padding:20px 0;">
              <a target="_blank" rel="noreferrer" href="https://beian.mps.gov.cn/#/query/webSearch?code=43012402000786" 
                 style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                 <img src="@/assets/images/beian/gwba.png" style="float:left;"/>
                 <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">湘公网安备43012402000786号</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.footer {
  background-color: #3D3E49;
  border-top: 1px solid #e6e6e6;
  .container {
    width: 100%;
    margin: 0 auto;
  }
  .copyright {
    color: #434d55;
    font-size: 12px;
    padding: 10px 10px;
    text-align: center;
    h4, h5 {
      // float: left;
      height: 15px;
      line-height: 15px;
      color: #bdbdbd;
    }
    h5 {
      margin-left: 3px;
      font-size: 12px;
    }
    h6 {
      clear: both;
      padding: 10px 0 0;
      height: 25px;
      font-size: 12px;
      a {
        color: #bdbdbd;
        font-size: 12px;
        height: 12px;
        line-height: 1;
      }
      span {
        margin-right: 10px;
        color: #bdbdbd;
        font-size: 12px;
        height: 12px;
        line-height: 1;
      }
    }
  }
}
.siteinfo {
  padding: 0px 0 0px;
  // border-bottom: 1px solid #e6e6e6;
  border-bottom: .5px solid rgba(255,255,255,.25);
  font-size: 0;
  .content::after {
    content: '';
    display: table;
    clear: both;
  }
  .nav-left {
    float: left;
    h3 {
      color: #fff;
      font-size: 14px;
      // padding: 0 0 14px;
    }
    p, li {
      color: #c3c3c3;
      font-size: 12px;
      // padding: 6px 0;
      a {
        color: #c3c3c3;
      }
    }
    img {
      //cursor: pointer;
      width: 50%;
      height: 50%;
    }
  }
  .nav-right {
    float: right;
    width: 20%;
    .tel {
      font-size: 30px;
      line-height: 1;
      width: 241px;
      text-align: right;
      a {
        color: #646464;
      }
    }
    .time {
      text-align: right;
      width: 241px;
      font-size: 12px;
      line-height: 24px;
      color: #c3c3c3;
      position: relative;
      right: -5px;
      a {
        color: #c3c3c3;
      }
    }
  }
  .contactUs {
    width: 50%;
  }
  .weixin {
    width: 25%;
  }
  .weibo {
    width: 25%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Footer.vue